export default __webpack_public_path__ + "static/media/77_Agent_Sunny_footer_return.e36bf007.png";